import React from 'react'
import ex_img from "../assets/images/ex2_img.png"
import ReactStars from "react-rating-stars-component";
import { ReactComponent as StarIcon } from "../assets/icons/starIcon.svg";
import { ReactComponent as EmptyStarIcon } from "../assets/icons/emptyStarIcon.svg";
import { ReactComponent as Eye } from "../assets/icons/eye.svg";
import { ReactComponent as Like } from "../assets/icons/like.svg";
import { ReactComponent as Dislike } from "../assets/icons/dislike.svg";
import { ReactComponent as Bookmark } from "../assets/icons/bookmark.svg";

export default function Card() {
    return (
        <div className="card-main">
            <div className="card-header">
                <img src={ex_img} alt=""/>
                <div>
                    <p>نام محصول</p>
                    <div className="rate-section" >
                        <span>4.5</span>
                        <div className="rating-stars" dir="ltr">
                            <ReactStars
                            count={5}
                            size={20}
                            activeColor="#FEB730"
                            filledIcon={<StarIcon />}
                            emptyIcon={<EmptyStarIcon />}
                            />
                        </div>
                    </div>
                </div>
                <button><Bookmark /></button>
            </div>
            <div className="card-des">لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.</div>
            <div className="card-detail">
                <div>
                    <div>
                        <div>25</div>
                    </div>
                    <Dislike />
                </div>
                <div>
                    <div>
                        <div>25</div>
                    </div>
                    <Like />
                </div>
                <div>
                    <div>
                        <div>25</div>
                    </div>
                    <Eye />
                </div>
            </div>
        </div>
    )
}

